import {Alpha3CountryCode} from 'platform/components';

import {DefaultValues} from 'react-hook-form';

import {defaultTo} from 'ramda';

import {GetEmployeePersonalDataApiResponse} from '@dms/api/customer';
import {PhoneNumber} from '@dms/api/shared';

import {parseDate} from 'shared/web';

import {PersonalInfoForm} from '../types/PersonalInfoForm';

const defaultValue = defaultTo(undefined);

export const getPersonalInfoFormDefaultValues = (
  tenantPhoneInfo?: PhoneNumber,
  employee?: GetEmployeePersonalDataApiResponse
): DefaultValues<PersonalInfoForm> => ({
  addressData: {
    addressLine1: defaultValue(employee?.addressData?.addressLine1),
    addressLine2: defaultValue(employee?.addressData?.addressLine2),
    city: defaultValue(employee?.addressData?.city),
    countryCode: defaultValue(employee?.addressData?.countryCode),
    postalCode: defaultValue(employee?.addressData?.postalCode),
  },
  contactData: {
    emailPrivate: defaultValue(employee?.contactData?.emailPrivate),
    emailWork: defaultValue(employee?.contactData?.emailWork),
    phoneNumberPrivate: {
      prefix: employee?.contactData?.phoneNumberPrivate?.prefix ?? tenantPhoneInfo?.prefix,
      number: employee?.contactData?.phoneNumberPrivate?.number ?? '',
      countryCode: (employee?.contactData?.phoneNumberPrivate?.countryCode ??
        tenantPhoneInfo?.countryCode) as Alpha3CountryCode,
    },
    phoneNumberWork: {
      prefix: employee?.contactData?.phoneNumberWork?.prefix ?? tenantPhoneInfo?.prefix,
      number: employee?.contactData?.phoneNumberWork?.number ?? '',
      countryCode: (employee?.contactData?.phoneNumberWork?.countryCode ??
        tenantPhoneInfo?.countryCode) as Alpha3CountryCode,
    },
  },
  employmentData: {
    endDate: parseDate(employee?.employmentData?.endDate) ?? undefined,
    startDate: parseDate(employee?.employmentData?.startDate) ?? undefined,
  },
  note: defaultValue(employee?.note),
  personalData: {
    birthdate: parseDate(employee?.personalData?.birthdate) ?? undefined,
    firstName: defaultValue(employee?.personalData?.firstName),
    genderKey: defaultValue(employee?.personalData?.genderKey),
    identificationNumber: defaultValue(employee?.personalData?.identificationNumber),
    lastName: defaultValue(employee?.personalData?.lastName),
    titleAfter: defaultValue(employee?.personalData?.titleAfter),
    titleBefore: defaultValue(employee?.personalData?.titleBefore),
    fte: defaultValue(employee?.personalData?.fte),
  },
  publicId: defaultValue(employee?.publicId),
});
